import { useTranslation } from "react-i18next";
import { AssetViewDetails } from "@/custolink-views/asset_frontend/asset_view/useAssetViewFacade";

export default function AssetDescriptionForHeader(p: {
  viewDetails: AssetViewDetails;
}) {
  const { t } = useTranslation();
  return (
    <div className={""}>
      <div className="">
        <div
          className={"bg-white rounded-2xl shadow-xl"}
          style={{
            boxShadow: "rgb(80 80 80 / 100%) 0px 5px 15px",
          }}
        >
          {
            <div className="p-4 text-black">
              {p.viewDetails.inferredDefaultView != null && (
                <>
                  <p className={"text-2xl"}>{p.viewDetails.assetProductName}</p>
                  <p className={"text-xs"}>
                    {t("assetView.serialnumber.shortened")}
                    &nbsp;
                    {p.viewDetails.inferredDefaultView.serialNumber}
                  </p>
                </>
              )}
              {p.viewDetails.inferredSerialnumberPatternMatchView != null && (
                <>
                  <p className={"text-2xl"}>{p.viewDetails.assetProductName}</p>
                  <p className={"text-xs"}>
                    {t("assetView.serialnumber.shortened")}
                    &nbsp;
                    {p.viewDetails.inferredSerialnumberPatternMatchView.serialNumber}
                  </p>
                </>
              )}
              {p.viewDetails.inferredCategoryView != null && (
                <>
                  <p className={"text-2xl"}>{p.viewDetails.assetProductName}</p>
                  <p className={"text-xs"}>
                    {p.viewDetails.inferredCategoryView.uiTitle}
                    &nbsp;
                    {p.viewDetails.inferredCategoryView.viewValue}
                  </p>
                </>
              )}
            </div>
          }
        </div>
      </div>
    </div>
  );
}
